import {
  RequestCancellationFormValues,
  ResolveCancellationFormValues,
} from './pre-billing-cancellation-modals.types'

type RequestErrors = Partial<Record<keyof RequestCancellationFormValues, string>>
type ResolveErrors = Partial<Record<keyof ResolveCancellationFormValues, string>>

/**
 * Validates the request-cancellation comment (required, non-whitespace).
 */
export const validateRequestCancellationForm = (
  values: RequestCancellationFormValues,
): RequestErrors => {
  const errors: RequestErrors = {}
  if (!values.requestComment?.trim()) {
    errors.requestComment = 'Le commentaire est obligatoire'
  }
  return errors
}

/**
 * Validates the resolve-cancellation form (comment required; decision has a default).
 */
export const validateResolveCancellationForm = (
  values: ResolveCancellationFormValues,
): ResolveErrors => {
  const errors: ResolveErrors = {}
  if (!values.resolutionComment?.trim()) {
    errors.resolutionComment = 'Le commentaire est obligatoire'
  }
  return errors
}
